
import Navbar from './components/navbar/Navbar';
import Home from './components/home/Home';
import './App.css';
import Footer from './components/footer/Footer';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Home />
      <Footer />
    </div>
  );
}

export default App;
